import { apiAxios } from "./apiConfig";

/* ================= TYPES ================= */

export interface MessageTemplate {
  id: string;
  messageTitle: string;
  messageDescription: string;
  messageMetric: string;
  messageCondition: string;
  messageValue: number;
  messageTriggerTime: string;
  messageTriggerTimezone: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  creator: {
    name: string;
  } | null;
  updater: any;
}

export interface MessageTemplateListResponse {
  status: boolean;
  data: MessageTemplate[];
}

/* ================= API ================= */

export const getMessageTemplateList =
  async (): Promise<MessageTemplateListResponse> => {
    const response = await apiAxios.get("/message-template/list");
    return response.data;
  };

/* ================= CREATE API ================= */

export interface CreateMessageTemplatePayload {
  messageTitle: string;
  messageDescription: string;
  messageMetric: string;
  messageCondition: string;
  messageValue: number;
  messageTriggerTime: string;
  messageTriggerTimezone: string;
}

export interface CreateMessageTemplateResponse {
  status: boolean;
  data: MessageTemplate;
}

export const createMessageTemplate = async (
  payload: CreateMessageTemplatePayload,
): Promise<CreateMessageTemplateResponse> => {
  const response = await apiAxios.post("/message-template/create", payload);
  return response.data;
};

/* ================= UPDATE API ================= */

export interface UpdateMessageTemplatePayload {
  id: string;
  messageTitle: string;
  messageDescription: string;
  messageMetric: string;
  messageCondition: string;
  messageValue: number;
  messageTriggerTime: string;
  messageTriggerTimezone: string;
  isActive: boolean;
  isDeleted: boolean;
}

export interface UpdateMessageTemplateResponse {
  status: boolean;
  data: MessageTemplate[]; // API returns array
}

export const updateMessageTemplate = async (
  payload: UpdateMessageTemplatePayload,
): Promise<UpdateMessageTemplateResponse> => {
  const { id, ...body } = payload;

  const response = await apiAxios.put(`/message-template/${id}`, body);

  return response.data;
};
